import { APIMethod, fetchData } from "@client";

export async function updateLibraryElementNameQuery(elementId, name, content) {
  await fetchData(`/v1/library/${elementId}`, APIMethod.PATCH, {
    data: { name, content },
  });
}
